import {
  USER_TIMING_TODAY_LIST_FAIL,
  USER_TIMING_TODAY_LIST_REQUEST,
  USER_TIMING_TODAY_LIST_SUCCESS,
  USER_TIMING_MONTH_LIST_FAIL,
  USER_TIMING_MONTH_LIST_REQUEST,
  USER_TIMING_MONTH_LIST_SUCCESS,
  USER_TIMING_PREV_LIST_FAIL,
  USER_TIMING_PREV_LIST_REQUEST,
  USER_TIMING_PREV_LIST_SUCCESS,
  USER_RANGE_DASHBOARD_LIST_FAIL,
  USER_RANGE_DASHBOARD_LIST_REQUEST,
  USER_RANGE_DASHBOARD_LIST_SUCCESS,
  USER_WEEK_DASHBOARD_LIST_FAIL,
  USER_WEEK_DASHBOARD_LIST_REQUEST,
  USER_WEEK_DASHBOARD_LIST_SUCCESS,
  USER_RANGE_WISE_TIME_LIST_FAIL,
  USER_RANGE_WISE_TIME_LIST_REQUEST,
  USER_RANGE_WISE_TIME_LIST_SUCCESS,
  USER_DASHBOARD_TIMING_TODAY_LIST_REQUEST,
  USER_DASHBOARD_TIMING_TODAY_LIST_SUCCESS,
  USER_DASHBOARD_TIMING_TODAY_LIST_FAIL,
} from "../../types/user/TimesTypes";

export const timeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TIMING_TODAY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_TIMING_TODAY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        UserTimeInfo: payload,
        error: "",
      };
    case USER_TIMING_TODAY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        UserTimeInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};
export const userDashTodayTimesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_DASHBOARD_TIMING_TODAY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_DASHBOARD_TIMING_TODAY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userDashTodayTimesInfo: payload,
        error: "",
      };
    case USER_DASHBOARD_TIMING_TODAY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        userDashTodayTimesInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const timeDashReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TIMING_TODAY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_TIMING_TODAY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        UserTimeInfo: payload,
        error: "",
      };
    case USER_TIMING_TODAY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        UserTimeInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const timePrevReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TIMING_PREV_LIST_REQUEST:
      return {
        ...state,
        PrevLoading: true,
      };
    case USER_TIMING_PREV_LIST_SUCCESS:
      return {
        ...state,
        PrevLoading: false,
        UserPrevTimeInfo: payload,
        PrevError: "",
      };
    case USER_TIMING_PREV_LIST_FAIL:
      return {
        ...state,
        PrevLoading: false,
        UserPrevTimeInfo: [],
        PrevError: payload,
      };
    default:
      return state;
  }
};

export const userMonthTimeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TIMING_MONTH_LIST_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case USER_TIMING_MONTH_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        monthTimerList: payload,
        Error: "",
      };
    case USER_TIMING_MONTH_LIST_FAIL:
      return {
        ...state,
        Loading: false,
        monthTimerList: [],
        Error: payload,
      };
    default:
      return state;
  }
};

export const userDasboardReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_RANGE_DASHBOARD_LIST_REQUEST:
      return {
        ...state,
        userDashLoading: true,
      };
    case USER_RANGE_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        userDashLoading: false,
        userDashList: payload,
        userDashError: "",
      };
    case USER_RANGE_DASHBOARD_LIST_FAIL:
      return {
        ...state,
        userDashLoading: false,
        userDashList: [],
        userDashError: payload,
      };
    default:
      return state;
  }
};

export const userWeekReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_WEEK_DASHBOARD_LIST_REQUEST:
      return {
        ...state,
        userDashWeekLoading: true,
      };
    case USER_WEEK_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        userDashWeekLoading: false,
        userDashWeekInfo: payload,
        userDashWeekError: "",
      };
    case USER_WEEK_DASHBOARD_LIST_FAIL:
      return {
        ...state,
        userDashWeekLoading: false,
        userDashWeekInfo: [],
        userDashWeekError: payload,
      };
    default:
      return state;
  }
};

export const userRangeWiseTimeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_RANGE_WISE_TIME_LIST_REQUEST:
      return {
        ...state,
        userTotalTimeLoading: true,
      };
    case USER_RANGE_WISE_TIME_LIST_SUCCESS:
      return {
        ...state,
        userTotalTimeLoading: false,
        userTotalTimeInfo: payload,
        userTotalTimeError: "",
      };
    case USER_RANGE_WISE_TIME_LIST_FAIL:
      return {
        ...state,
        userTotalTimeLoading: false,
        userTotalTimeInfo: [],
        userTotalTimeError: payload,
      };
    default:
      return state;
  }
};
